// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M14.3916 2C13.8287 2.86298 13.5 3.89279 13.5 5C13.5 8.03757 15.9624 10.5 19 10.5C20.1072 10.5 21.137 10.1713 22 9.6084V22H2V2H14.3916ZM8.75 16.5L16.75 12L8.75 7.5V16.5Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M20.4551 3.54395L23.6797 5L20.4551 6.45508L19 9.67969L17.5439 6.45508L14.3203 5L17.5439 3.54395L19 0.320312L20.4551 3.54395Z"}}]};

const AiVideoFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'ai-video-filled',
    ref,
    icon: element,
  },
));

AiVideoFilledIcon.displayName = 'AiVideoFilledIcon';

export default AiVideoFilledIcon;
